import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const About = () => {
  const whyTenSolar = [
    'Government-ready execution',
    'Strong engineering discipline',
    'Compliance-first approach',
    'Climate-positive impact'
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">About Us</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed text-lg">
                <p>
                  TenSolar Energy India Pvt. Ltd. is built to support India's transition to renewable power at scale. We specialize in designing and deploying large solar power plants that meet strict technical, regulatory, and grid-integration requirements.
                </p>
                <p>
                  Our team brings together experience in project execution, compliance, and on-ground delivery—ensuring timelines, safety, and performance are never compromised.
                </p>
                <p className="font-medium text-emerald-800">
                  We believe clean energy is not just sustainable—it is essential infrastructure for India's future.
                </p>
              </div>
            </div>

            {/* Why TenSolar */}
            <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Why TenSolar</h3>
              <ul className="space-y-4">
                {whyTenSolar.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700 text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Column - Visual Element */}
          <div className="relative">
            <div className="aspect-square rounded-2xl bg-gradient-to-br from-emerald-100 via-white to-amber-100 p-1">
              <div className="w-full h-full rounded-2xl bg-white flex items-center justify-center">
                <div className="text-center p-8 space-y-6">
                  <div className="w-24 h-24 bg-emerald-700 rounded-full mx-auto flex items-center justify-center">
                    <Sun className="w-12 h-12 text-white" />
                  </div>
                  <div>
                    <div className="text-5xl font-bold text-gray-900 mb-2">10 MW</div>
                    <div className="text-xl text-gray-600">Solar Power Plant</div>
                    <div className="text-lg text-emerald-700 font-medium mt-2">Madhya Pradesh</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

import { Sun } from 'lucide-react';

export default About;
